// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  width: 100% !important;
}

.wrapper {
  height: 100vh;
}

@media screen and (max-width: 767px) {
  .body {
    padding: 0rem;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .body {
    padding: 0rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/admin-layout/admin-layout.component.scss"],"names":[],"mappings":"AAAA;EAEI,sBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI;IACI,aAAA;EAAN;AACF;AAKA;EACI;IACI,aAAA;EAHN;AACF","sourcesContent":[".body {\n    // margin-top: 80px;\n    width: 100% !important;\n}\n\n.wrapper {\n    height: 100vh;\n}\n\n@media screen and (max-width: 767px) {\n    .body {\n        padding: 0rem;\n        // top: 170px;\n    }\n\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n    .body {\n        padding: 0rem;\n        // top: 170px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
